import React from "react";
import ServiceWorld from "../../../components/Serviceworld/ServiceWorld";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

const ServiceWorldPage = () => {
  const title = "Servicewelt | Legalbird";
  gaSet({ title: title });

  return (
    <LayoutAuthenticated>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <ServiceWorld />
    </LayoutAuthenticated>
  );
};

export default ServiceWorldPage;
